import { render, staticRenderFns } from "./DashNegotiationSettled.vue?vue&type=template&id=4f5f3762&scoped=true&"
import script from "./DashNegotiationSettled.vue?vue&type=script&lang=js&"
export * from "./DashNegotiationSettled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5f3762",
  null
  
)

export default component.exports